function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLikeActiveIcon = function SvgLikeActiveIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.394 130.394",
    width: 22.5,
    height: 22.5,
    style: {
      enableBackground: "new 0 0 130.394 130.394"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fe9800"
    },
    d: "M119.692 20.494c-12.67-12.68-33.22-12.68-45.89 0a32.293 32.293 0 0 0-8.61 15.35 32.237 32.237 0 0 0-8.6-15.35c-12.67-12.68-33.22-12.68-45.89 0-12.67 12.67-12.67 33.22 0 45.89l51.99 51.99a3.549 3.549 0 0 0 5.01 0l51.99-51.99c12.67-12.67 12.67-33.21 0-45.89z"
  }));
};

export default SvgLikeActiveIcon;